export const placeImage = (file) => {
  // Send message to parent to call an action 'insertImage'
  window.parent.postMessage({
    action: 'insertImage',
    file: file
  }, '*')
}
